
export enum DeviceType {
  NotSet = 0,
  Android = 1,
  Apple = 2,
  WindowsPhone = 3,
  BlackBerry = 4
}
